import {useOpenModal} from '@/components/Modal/index.mjs'
import openWindow from '@/script/openWindow.mjs'
import AiIsrfDlg from '@/pages/MainPage/panes/PrjPatternDetail/AiIsrfDlg.jsx'

export const canAiGenerateSrfFast = () => () => {
    return function (nodes) {
        return [...nodes].filter(node => {
            const {bizNodeType, pkid, prjId} = node.data

            return (
                pkid &&
                prjId === this.data.prjId &&
                /^(BD|DM|DT|FM|UI)$/.test(bizNodeType)
            )
        })
    }
}

export const aiGenerateSrfFast = () => () => {
    const openModal = useOpenModal()

    return async function (nodes) {
        const ns = this.commands.canAiGenerateSrf(nodes)
        const {prjId, prjPatternId, sVer} = this.data
        const dmIds = []
        const fmIds = []
        const bdIdList = []
        const modules = []

        for (const n of ns) {
            const {bdName, bizNodeType, dtName, pkid, uiName} = n.data

            if ('DM' === bizNodeType) {
                dmIds.push(pkid)
            }
            else if ('FM' === bizNodeType) {
                fmIds.push(pkid)
            }
            else if ('BD' === bizNodeType) {
                bdIdList.push(pkid)
            }
            else {
                modules.push({
                    moduleId: pkid,
                    moduleName: bdName ?? dtName ?? uiName,
                    moduleType: bizNodeType,
                })
            }
        }

        const param = {bdIds: bdIdList, dmIds, fmIds, modules, prjPatternId, prjId, sVer}
        const result = await openModal(<AiIsrfDlg param={param} />)

        if (! result) {
            return
        }

        const {
            bdIds,
            dpSn: srfNo,
            files,
            pkid: srfId,
            reqDesc,
            uiIds,
            dtIds,
        } = result

        const prjs = [{patternId: prjPatternId}]

        openWindow(
            '/Ai',

            {
                bizMap: {bdIds, prjs, srfId, srfNo, uiIds, dtIds},
                prjId,
                scene: 'GENERATE_SRF_FAST',
                sVer,
                defaultDraft: JSON.stringify({content: reqDesc, files}),
            }
        )
    }
}
